<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 12 9">
    <path
      d="M2 4.5L4.88 7L10 2"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCheck',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 0.875em;
  height: 0.875em;
  fill: none;
  flex-shrink: 0;
}
</style>
